(function () {
  const AUTOPLAY_MS = 6000;

  document.querySelectorAll('[data-eden-campaign]').forEach((root) => {
    const track = root.querySelector('[data-eden-track]');
    const slides = [...root.querySelectorAll('.campaign-slide')];
    const dots = [...root.querySelectorAll('[data-eden-dot]')];
    const prev = root.querySelector('[data-eden-prev]');
    const next = root.querySelector('[data-eden-next]');
    const live = root.querySelector('[data-eden-live]');
    if (!track || slides.length <= 1) return;

    let index = 0;
    let paused = false;
    let timer;

    const update = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      slides.forEach((slide, n) => slide.setAttribute('aria-hidden', n === index ? 'false' : 'true'));
      dots.forEach((dot, n) => dot.classList.toggle('active', n === index));
      if (live) live.textContent = `Banner ${index + 1} de ${slides.length}: ${slides[index].dataset.title || ''}`;
    };

    const go = (i) => update(i);

    const autoplayOff = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(max-width: 749px)').matches;

    const restart = () => {
      clearInterval(timer);
      if (paused || autoplayOff()) return;
      timer = setInterval(() => {
        if (!document.hidden) go(index + 1);
      }, AUTOPLAY_MS);
    };

    prev?.addEventListener('click', () => { go(index - 1); restart(); });
    next?.addEventListener('click', () => { go(index + 1); restart(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { go(Number(dot.dataset.edenDot)); restart(); }));

    root.addEventListener('mouseenter', () => { paused = true; clearInterval(timer); });
    root.addEventListener('mouseleave', () => { paused = false; restart(); });
    root.addEventListener('focusin', () => { paused = true; clearInterval(timer); });
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { paused = false; restart(); } });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); restart(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); restart(); }
    });

    update(0);
    restart();
  });
})();
